import { format, subDays, subMonths, startOfMonth, startOfQuarter, startOfYear } from 'date-fns'
import type { DashboardPeriod } from '@/hooks/dashboardDataTypes'

export function getDateRange(period: DashboardPeriod): { start_date: string; end_date: string } {
  const now = new Date()
  const end = format(now, 'yyyy-MM-dd')
  let start: string

  switch (period) {
    case 'Esta semana':
      start = format(subDays(now, 7), 'yyyy-MM-dd')
      break
    case 'Este mês':
      start = format(startOfMonth(now), 'yyyy-MM-dd')
      break
    case 'Último trimestre':
      start = format(startOfQuarter(now), 'yyyy-MM-dd')
      break
    case 'Este ano':
      start = format(startOfYear(now), 'yyyy-MM-dd')
      break
    case 'Últimos 12 meses':
      start = format(startOfMonth(subMonths(now, 11)), 'yyyy-MM-dd')
      break
  }

  return { start_date: start, end_date: end }
}
